import _extends from "@babel/runtime/helpers/extends";
import { css, jsx } from '@emotion/react';
import * as React from 'react';
import LazyLoad from 'react-lazyload';
import SkeletonImage from '../Skeleton/SkeletonImage';
const StyledImage = _ref => {
  let {
    display,
    objectFit,
    cssWidth,
    cssHeight,
    translate,
    scale,
    borderRadius,
    ...rest
  } = _ref;
  const imageStyles = css("border:0;", display ? "display: ".concat(display, ";") : '', " ", objectFit ? "object-fit: ".concat(objectFit, ";") : '', " ", cssWidth ? "width: ".concat(cssWidth, ";") : '', " ", cssHeight ? "height: ".concat(cssHeight, ";") : '', " ", translate ? "transform: translate(".concat(translate, ");") : '', " ", scale ? "transform: scale(".concat(scale, ");") : '', " ", borderRadius ? "border-radius: ".concat(borderRadius, ";") : '', ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
  return jsx("img", _extends({
    css: imageStyles
  }, rest));
};
const Image = _ref2 => {
  let {
    isLazy,
    lazyHeight,
    offSet,
    placeholder,
    lazyDisplay,
    once,
    ...rest
  } = _ref2;
  const imgHeight = lazyHeight || rest && rest.height || '100%';
  return isLazy ? jsx(LazyLoad, {
    height: imgHeight,
    once: once,
    placeholder: placeholder && imgHeight ? jsx(SkeletonImage, null) : null,
    offset: offSet ? offSet : 100,
    style: {
      display: lazyDisplay ? lazyDisplay : 'block'
    }
  }, jsx(StyledImage, rest)) : jsx(StyledImage, rest);
};
Image.displayName = 'Image';
Image.defaultProps = {
  isLazy: false,
  lazyHeight: null,
  offSet: 100,
  placeholder: false,
  lazyDisplay: 'block',
  once: true
};
export default Image;
//# sourceMappingURL=index.js.map